import axios, { AxiosInstance } from 'axios';

export class NewRelicTransport {
  private readonly app_name: string;
  private api: AxiosInstance;

  constructor(api_key: string, app_name: string) {
    this.app_name = app_name;

    this.api = axios.create({
      baseURL: 'https://log-api.eu.newrelic.com/',
      headers: {
        'Content-Type': 'application/json',
        'Api-Key': api_key,
      },
    });
  }

  //todo starostin: replace "any" with some type
  public sendLog(level: 'info' | 'warn' | 'error', message: string, newRelicParams: any): void {
    const payload = [
      {
        message: message,
        level: level,
        timestamp: Date.now(),
        attributes: {
          app: this.app_name,
          ...newRelicParams.meta,
        },
      },
    ];

    this.api.post('log/v1', payload).catch((err: { message: any }) => {
      console.error('New Relic log error:', err?.message || err);
    });
  }
}
